(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider 
        .state('event-form-category', {
            parent: 'entity',
            url: '/event-form-category?page&sort&search',
            data: {
                authenticate: true,
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'wamasysApp.EventFormCategory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/event-form-category/event-form-categorys.html',
                    controller: 'EventFormCategoryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventFormCategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('event-form-category-detail', {
            parent: 'entity',
            url: '/event-form-category/{id}',
            data: {
                authenticate: true,
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'wamasysApp.EventFormCategory.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/event-form-category/event-form-category-detail.html',
                    controller: 'EventFormCategoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventFormCategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'EventFormCategory', function($stateParams, EventFormCategory) {
                    return EventFormCategory.get({id : $stateParams.id});
                }]
            }
        })
        .state('event-form-category-matrix', {
            parent: 'entity',
            url: '/event-form-category-matrix',
            data: {
                authenticate: true,
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'wamasysApp.EventFormCategory.matrix.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/event-form-category/event-form-category-matrix.html',
                    controller: 'EventFormCategoryMatrixController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventFormCategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })

        .state('event-form-category.new', {
            parent: 'event-form-category',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/event-form-category/event-form-category-dialog.html',
                    controller: 'EventFormCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                label: null,
                                deleted: false,
                                visibleOnSmartphone: true,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('event-form-category', null, { reload: true });
                }, function() {
                    $state.go('event-form-category');
                });
            }]
        })
        .state('event-form-category.edit', {
            parent: 'event-form-category',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/event-form-category/event-form-category-dialog.html',
                    controller: 'EventFormCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EventFormCategory', function(EventFormCategory) {
                            return EventFormCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-form-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('event-form-category.delete', {
            parent: 'event-form-category',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/event-form-category/event-form-category-delete-dialog.html',
                    controller: 'EventFormCategoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EventFormCategory', function(EventFormCategory) {
                            return EventFormCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-form-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('event-form-category-detail.new-sub-category', {
            parent: 'event-form-category-detail',
            url: '/subcategory/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/event-form-category/event-form-sub-category-dialog.html',
                    controller: 'EventFormSubCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                label: null,
                                deleted: false,
                                eventFormCategory:{id:$stateParams.id},
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('event-form-category-detail', {id: $stateParams.id}, { reload: true });
                }, function() {
                    $state.go('event-form-category-detail', {id: $stateParams.id});
                });
            }]
        })
        .state('event-form-category-detail.edit-sub-category', {
            parent: 'event-form-category-detail',
            url: '/subcategory/{idSubCategory}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/event-form-category/event-form-sub-category-dialog.html',
                    controller: 'EventFormSubCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EventFormCategory', function(EventFormCategory) {
                            return EventFormCategory.getSubCategory({id : $stateParams.idSubCategory});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-form-category-detail', {id: $stateParams.id}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        
        .state('event-form-category-detail.delete-sub-category', {
            parent: 'event-form-category-detail',
            url: '/subcategory/{idSubCategory}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/event-form-category/event-form-sub-category-delete-dialog.html',
                    controller: 'EventFormSubCategoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EventFormCategory', function(EventFormCategory) {
                            return {id : $stateParams.idSubCategory};
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-form-category-detail', {id: $stateParams.id}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        
        ;
    }

})();
